import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * This component is responsible for adding all of the link and meta elements to the
 * head of the document that are required to configure a favicon.
 *
 * Favicon assets have been generated with https://realfavicongenerator.net.
 */
export class Favicon extends Component {
  /**
   * Path to the favicon assets.
   *
   * @static
   * @memberof Favicon
   */
  static PATH = '/static/favicon';

  /**
   * Generates a list of every link element that needs to be injected in the head
   * of the document.
   *
   * @static
   * @returns {Array} Array of link objects.
   * @memberof Favicon
   */
  static getLink() {
    const link = [
      {
        rel: 'apple-touch-icon',
        sizes: '180x180',
        href: `${Favicon.PATH}/apple-touch-icon.png`
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '32x32',
        href: `${Favicon.PATH}/favicon-32x32.png`
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '16x16',
        href: `${Favicon.PATH}/favicon-16x16.png`
      },
      {
        rel: 'manifest',
        href: `${Favicon.PATH}/site.webmanifest`
      },
      {
        rel: 'mask-icon',
        href: `${Favicon.PATH}/safari-pinned-tab.svg`,
        color: '#5bbad5'
      },
      {
        rel: 'shortcut icon',
        href: `${Favicon.PATH}/favicon.ico`
      }
    ];

    return link;
  }

  /**
   * Generates a list of every meta element that needs to be injected in the head
   * of the document.
   *
   * @static
   * @returns {Array} Array of meta objects.
   * @memberof Favicon
   */
  static getMeta() {
    const meta = [
      {
        name: 'msapplication-TileColor',
        content: '#ffffff'
      },
      {
        name: 'msapplication-config',
        content: `${Favicon.PATH}/browserconfig.xml`
      },
      {
        name: 'theme-color',
        content: '#ffffff'
      }
    ];

    return meta;
  }

  /**
   * Render.
   *
   * @returns {Component}
   * @memberof Favicon
   */
  render() {
    return <Helmet meta={Favicon.getMeta()} link={Favicon.getLink()} />;
  }
}

// Add default export to maintain backward compatibility
export default Favicon;
